import { render } from "./InputLabel.vue?vue&type=template&id=3093b611"
import script from "./InputLabel.vue?vue&type=script&lang=js"
export * from "./InputLabel.vue?vue&type=script&lang=js"
script.render = render

export default script